export function formatRaceTime(milliseconds: number | null): string {
  if (milliseconds === null || !Number.isFinite(milliseconds) || milliseconds < 0) {
    return '--:--.---';
  }
  const whole = Math.max(0, Math.floor(milliseconds));
  const minutes = Math.floor(whole / 60_000);
  const seconds = Math.floor((whole % 60_000) / 1_000);
  const millis = whole % 1_000;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}.${String(millis).padStart(3, '0')}`;
}

export function formatDelta(milliseconds: number | null): string {
  if (milliseconds === null || !Number.isFinite(milliseconds)) return '—';
  const sign = milliseconds > 0 ? '+' : milliseconds < 0 ? '−' : '±';
  return `${sign}${(Math.abs(milliseconds) / 1000).toFixed(3)}s`;
}

export function displaySpeed(speedMps: number, unit: 'mph' | 'kmh'): number {
  return Math.max(0, Math.round(speedMps * (unit === 'mph' ? 2.236936 : 3.6)));
}
